import React from 'react';
import { downloadCSVSample } from '../../../util_funs/csvUtils';

const CSVSampleDownloadButton = ({
  filename,
  headers,
  sampleData = [],
  label = 'Download Sample',
  className = 'btn add-link',
  fontWeight = 500,
}) => {
  const handleDownload = () => {
    downloadCSVSample(filename, headers, sampleData);
  };

  return (
    <button
      className={className}
      onClick={handleDownload}
      style={{fontSize : 14, fontWeight : fontWeight,}}
    >
      {label}
    </button>
  );
};

export default CSVSampleDownloadButton;
